import React from "react";
import { connect } from "react-redux";
import styled, { withTheme } from "styled-components";
import BookSwimlane, { HEADER_TYPES } from "../../bookviews/book-swimlane";
import BridgeBook from "../../book/bridge-book";
import FetchingSpinner from "../../../../components/spinner/render-prop-spinner";
import {
  actions as bridgeActions,
  selectors as bridgeSelectors
} from "../../../../../redux/bridge";
import { withAllMatches } from "../../../../components/mediaquery/breakpoints";
import {
  formatBrandedSubscriptionParams,
  brandedSubscriptionParams
} from "../../../../../redux/bridge/utils";

const Styled = {
  LanesContainer: styled.div`
    margin-bottom: 10px;
  `
};

class BrandedSubscriptionLanes extends React.Component {
  componentDidMount() {
    const { fetchLists, vbids } = this.props;
    if (vbids && vbids.length > 0) {
      fetchLists(brandedSubscriptionParams(vbids));
    }
  }

  render() {
    const {
      vbids,
      assetsByVbid,
      loadingByVbid,
      titlesByVbid,
      displayModesByVbid,
      expandSwimlane
    } = this.props;

    return (
      <Styled.LanesContainer>
        {vbids &&
          vbids.map(vbid => {
            const assets = assetsByVbid && assetsByVbid[vbid];
            const displayMode = displayModesByVbid[vbid];
            return (
              <FetchingSpinner
                key={`spinner-${vbid}`}
                loading={loadingByVbid[vbid]}
                component={() => {
                  return (
                    assets && (
                      <BookSwimlane
                        isbns={assets.map(asset => asset.vbid)}
                        BookObject={BridgeBook}
                        headerLabel={titlesByVbid[vbid]}
                        headerType={HEADER_TYPES.CLICKABLE}
                        onHeaderClick={() => {
                          expandSwimlane(vbid, assets, displayMode);
                        }}
                        count={assets.length}
                      />
                    )
                  );
                }}
              />
            );
          })}
      </Styled.LanesContainer>
    );
  }
}

const mapStateToProps = (state, props) => {
  const assets = {};
  const loading = {};
  const titles = {};
  const displayModes = {};
  const vbids = bridgeSelectors.getBrandedSubscriptionVbids(state);
  if (vbids) {
    vbids.forEach(vbid => {
      const params = formatBrandedSubscriptionParams(vbid);
      loading[vbid] = bridgeSelectors.isAssetsFetching(state, params);
      assets[vbid] = bridgeSelectors.getAssets(state, params);
      titles[vbid] = bridgeSelectors.getSubscriptionName(state, vbid);
      displayModes[vbid] = bridgeSelectors.getSubscriptionDisplayMode(
        state,
        vbid
      );
    });
  }
  return {
    vbids: vbids,
    assetsByVbid: assets,
    loadingByVbid: loading,
    titlesByVbid: titles,
    displayModesByVbid: displayModes
  };
};

const mapDispatchToProps = dispatch => ({
  fetchLists: lists => dispatch(bridgeActions.fetchLists(lists))
});

export default withAllMatches(
  withTheme(
    connect(mapStateToProps, mapDispatchToProps)(BrandedSubscriptionLanes)
  )
);
